import React from 'react';
import styled from 'styled-components';

const LetterWrap = styled.div`
    padding-top:5vh;
    padding-bottom:5vh;
    padding-left: 10vw;
    padding-right: 10vw;
    color: white;
    
    @media (max-width: 768px) {
        padding-left:4%;
        padding-right:4%;
    }

`;

const Title = styled.div`
    font-size: 5em;
    letter-spacing: 0.05em;
    padding:1vh 0 1vh 0;
    word-wrap:break-word;
    font-family: 'Lora,serif';

    @media (max-width: 768px) {
        font-size: 2em;
    }

`;

const Body = styled.div`
    font-size: 1.5em; 
    color: white;
    word-wrap:break-word;
    width:100%;
    font-family: 'Lora,serif';
    @media (max-width: 768px) {
        font-size: 1em;
    }
`;

const LetterEditor = () => {
    return (
        <LetterWrap>
            <Title>LETTER FROM THE EDITOR</Title>
            <Body>
                <p>Dear reader,</p>

                <p>
                Columbia students have long understood that one of the surest things about their college education is its eventual end. It is this inevitability that sparks prolonged deliberations over how our time here ought to be spent. As graduation approaches, the question becomes increasingly urgent: is college the moment to hone in on our preprofessional pursuits, or to instead lean into our impractical passions? There is no formula dictating how a Columbia student might answer this question, and neither path is without risk. Résumé bloat and fanciful post-college thinking are equally threatening. 
                </p>

                <p>
                Drawing on concerns born from the uncertainties of post-graduation life, students confront encroaching preprofessionalism in the pages of Spectator. “Degrees of Ambition” is a retrospective of Opinion pieces, authored by Columbia students and professors across six decades. Throughout these 10 pieces, authors give into preprofessional pressures, urge those in our community to retain their curiosities, and negotiate a middle ground that honors both ambition and exploration. Whatever their argument, each stance is thoughtfully shaped by an understanding of Columbia’s liberal arts ethos. 
                </p>

                <p>
                In this edition of the Scope, I offer a series of juncture points in Columbia’s ongoing conversation around preprofessionalism, aiming to illustrate the flux and evolution of students’ unease over the decades. Each of these pieces takes to task either the presence or absence of preprofessional structures at the University. For example, in the earliest piece in this curated archive, from 1965, Spectator’s editorial board critiques the absence of a general career office, which at the time existed only to guide premedical students. A forum, similar to Opinion’s current Discourse and Debates, finds Columbians bracing themselves for the College’s introduction of a business concentration in 2010. An op-ed examines the founding of Columbia’s Human Rights and Sustainable Development programs in the early 2010s, considering the programs’ efforts to merge liberal arts learning with real-world relevance. The most recent entry, from 2025, takes aim at the latest—and possibly strongest—manifestation of professional preparation: the proliferation of investment and consulting clubs on campus, which have become ever-present in student life. Within this archive, Opinion contributors wrestle with their beliefs about preprofessionalism—and their own self-schema—amid Columbia’s changing landscape.
                </p>

                <p>
                This Scope is an invitation to probe questions of preprofessionalism, not an all-encompassing record of all the ways the University has contended with preprofessionalism. Our hope is that this Scope helps you situate your own college experience within a wider conversation about the meaning and charge of higher education. 
                </p>

                <p>Sincerely,</p>

                <p>Su Ertekin-Taner</p>

                <p>Deputy Editor of Projects </p>
            </Body>
        </LetterWrap>
    );
};

export default LetterEditor;